<div>
    <div class="description">(Per Alabama Act No. 2012-533). This section is to be completed for spouses of active-duty
        military personnel or active-duty military personnel who would like to request an expedited review of the
        certification application packet.</div>
    <form [formGroup]="interalForm">
        <div *ngFor="let question of questions;let i=index;">
            <app-question [showHelpIcon]="false" [disabled]="isReadOnly()" [showTooltipIcon]="false" [formControlName]="'militaryQA'+i" [question]="question" [showControlButtons]="false" (valueChange)="valueChange($event)"></app-question>
        </div>
    </form>
</div>